import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowDown, ArrowUpRight } from 'lucide-react';
import content from '../../data/collection-showcases.json';
import scenes from '../../data/application-scenes.json';
import { optimizedSrc, optimizedSrcSet } from '../../lib/image-cdn';

export const CollectionShowcase = ({ slug, catalogueAnchor = 'catalogue-results' }) => {
  const collection = content[slug];
  if (!collection) return null;
  return <section data-testid={`collection-showcase-${slug}`} className="collection-editorial border-b bg-muted/20">
    <div className="max-w-[1320px] mx-auto px-4 sm:px-6 py-8 sm:py-12">
      <div className="grid lg:grid-cols-[1fr_1fr] gap-6 lg:gap-12 mb-8">
        <div className="min-w-0">
          <p className="text-xs uppercase text-muted-foreground mb-3" data-testid={`collection-purpose-${slug}`}>{collection.category}</p>
          <h2 className="text-base md:text-lg font-semibold mb-4" data-testid={`collection-editorial-heading-${slug}`}>{collection.heading}</h2>
          <p className="text-sm leading-relaxed text-muted-foreground" data-testid={`collection-description-${slug}`}>{collection.description}</p>
        </div>
        <div className="min-w-0">
          <h3 className="text-sm font-semibold mb-3">Specification considerations</h3>
          <p className="text-sm leading-relaxed text-muted-foreground" data-testid={`collection-selection-${slug}`}>{collection.selection}</p>
          <div className="flex flex-wrap gap-x-6 gap-y-3 mt-5">
            <a data-testid={`collection-browse-${slug}`} className="inline-flex items-center gap-2 text-sm underline underline-offset-4" href={`#${catalogueAnchor}`}>Browse the range <ArrowDown className="h-4 w-4" /></a>
            <Link data-testid={`collection-guide-${slug}`} className="inline-flex items-center gap-2 text-sm underline underline-offset-4" to={collection.guide}>Technical guidance <ArrowUpRight className="h-4 w-4" /></Link>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {collection.photos.map((key, index) => {
          const photo = scenes[key];
          return <figure key={key} data-testid={`collection-application-${slug}-${index}`} className="min-w-0">
            <div className="aspect-[4/3] overflow-hidden bg-muted">
              <img data-testid={`collection-application-image-${slug}-${index}`} src={optimizedSrc(photo.src, { w: 600 })}
                srcSet={optimizedSrcSet(photo.src, [300, 600, 900])} sizes="(max-width: 639px) 100vw, 33vw"
                alt={photo.alt} width="600" height="450" loading="lazy" decoding="async" className="w-full h-full object-contain" />
            </div>
            <figcaption data-testid={`collection-application-caption-${slug}-${index}`} className="text-xs font-medium pt-3">{photo.caption}</figcaption>
          </figure>;
        })}
      </div>
      <p data-testid={`collection-imagery-note-${slug}`} className="text-xs text-muted-foreground mt-5">Application inspiration. Illustrative scenes, not a record of LUMIBRIGHT installations or product performance.</p>
    </div>
  </section>;
};